var firestoretable = require('./firestoretable')

const state = {
  uploadedInvoicesCollectionName: 'uploadedInvoices',
  uploadFolderPath: 'invoiceuploads/',
  uploadFileName: '',
  uploadProgress: '',
  showUploadingModal: false,
  showUploadingSuccessModal: false,
  showUploadingFailedModal: false,
  showImportingModal: false,
  showImportingSuccessModal: false,
  showImportingFailedModal: false,
  importFailedMessage: '',
  all: [],
  headers: ['fileName', 'uploadedDate', 'status'],
  rowsPerPage: 20,
  currentPage: 1,
  totalRows: 0,
  showLoadingAnimation: false,
  showLoadingError: false,
  showNoResult: false,
  loadingErrorMessage: '',
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
}

const mutations = {
  toggleUploadingModal: function (state, show) {
    state.showUploadingModal = show
  },
  toggleUploadingSuccessModal: function (state, show) {
    state.showUploadingSuccessModal = show
  },
  toggleUploadingFailedModal: function (state, show) {
    state.showUploadingFailedModal = show
  },
  toggleImportingModal: function (state, show) {
    state.showImportingModal = show
  },
  toggleImportingSuccessModal: function (state, show) {
    state.showImportingSuccessModal = show
  },
  toggleImportingFailedModal: function (state, show) {
    state.showImportingFailedModal = show
  },
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    console.log('Mutated totalRows to: ' + state.totalRows)
  },
  selectTableRow: function (state, docId) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].docId === docId) {
        state.all[i]._rowVariant = 'info'
        console.log('selected docId:' + docId)
      } else {
        state.all[i]._rowVariant = ''
      }
    }
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  },
  toggleDisabledPagination: function (state, show) {
    state.disabledPagination = show
  }
}

const getters = {
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  }
}

const actions = {
  uploadFileToFirebaseStorage (context, payload) {
    console.log('File to upload: ' + payload.file)
    if (!payload.file) {
      console.log('Nothing to upload')
      return
    }
    let firebaseStorageRef = context.rootState.fbStorage.ref()
    context.commit('toggleUploadingModal', true)

    let uploadTask = firebaseStorageRef.child(context.state.uploadFolderPath + payload.file.name).put(payload.file)
    uploadTask.on('state_changed', function (snapshot) {
      context.state.uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      console.log('Upload is ' + context.state.uploadProgress + '% done')
      switch (snapshot.state) {
        case context.rootState.firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused')
          break
        case context.rootState.firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running')
          break
      }
    }, function (error) {
      context.commit('toggleUploadingModal', false)
      context.commit('toggleUploadingFailedModal', true)
      // Handle unsuccessful uploads
      console.error(error)
    }, function () {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      let downloadURL = uploadTask.snapshot.downloadURL
      console.log('Successfully uploaded to: ' + downloadURL)

      let objToAdd = {
        fileName: payload.file.name,
        uploadedDate: new Date(),
        status: 'NEW'
      }
      // write an entry into firestore
      let uploadedInvoiceCollection = context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName)
      uploadedInvoiceCollection.add(objToAdd)
        .then(function (docRef) {
          context.commit('toggleUploadingModal', false)
          context.commit('toggleUploadingSuccessModal', true)
          context.dispatch('showAllUploads', { orderBys: 'uploadedDate' })
        }).catch(function (err) {
          console.error(err)
          context.commit('toggleUploadingModal', false)
          context.commit('toggleUploadingFailedModal', true)
          // we leave the file there, cause next upload will overwrite it
        })
    })
  },
  showAllUploads (context, payload) {
    context.state.all = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    context.commit('toggleDisabledPagination', true)

    let queryParameters = {
      collectionName: context.state.uploadedInvoicesCollectionName,
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: payload.orderBys,
      orderByDirection: 'desc',
      orderByFlippedDirection: 'asc'
    }

    let docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters)

    firestoretable.queryCollection(docQuery, context, queryParameters, false)

    // count total rows
    let firstQuery = context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName)
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length)
    })
  },
  importFile (context, payload) {
    console.log('Import file at: ' + payload.downloadURL)
    context.commit('toggleImportingModal', true)
    context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName).where('status', '==', 'IMPORTING')
      .get().then(function (querySnapshot) {
        if (querySnapshot.size === 0) {
          // console.log('Nothing being imported yet')
          let docRef = context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName).doc(payload.docId)
          docRef.update({status: 'IMPORTING'}).then(function () {
            console.log('Import file updated to IMPORTING')
            context.dispatch('executeImport', payload)
          }).catch(function (err) {
            console.error(err)
          })
        } else {
          console.log('Cannot import more than 1 file at the same time')
          context.dispatch('showAllUploads', { orderBys: 'uploadedDate' })
          context.commit('toggleImportingModal', false)
        }
      })
  },
  executeImport (context, payload) {
    let currentUser = context.rootState.firebase.auth().currentUser
    if (!currentUser) {
      context.commit('toggleImportingModal', false)
      context.state.importFailedMessage = 'Please login again before importing.'
      context.commit('toggleImportingFailedModal', true)
      return
    }

    currentUser.getIdToken(true).then(function (idToken) {
      let projectId = context.rootState.firebase.app().options.projectId
      let cloudFunctionImportUrl = 'https://asia-southeast1-' + projectId + '.cloudfunctions.net/importFromStorage'
      console.log('Import function URL: ' + cloudFunctionImportUrl)
      var xmlHttp = new XMLHttpRequest()
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
          context.commit('toggleImportingModal', false)
          if (xmlHttp.status === 200) {
            context.commit('toggleImportingSuccessModal', true)
            context.dispatch('updateFileStatus', {docId: payload.docId, status: 'IMPPORTED'})
            console.log('Import result: ' + xmlHttp.responseText)
            context.dispatch('showAllUploads', { orderBys: 'uploadedDate' })
          } else {
            // TODO: check the actual imports collection to check the status
            console.log('Import failed with status ' + xmlHttp.status + ': ' + xmlHttp.responseText)
            context.state.importFailedMessage = xmlHttp.responseText
            context.dispatch('updateFileStatus', {docId: payload.docId, status: 'NEW'})
            context.commit('toggleImportingFailedModal', true)
            context.dispatch('showAllUploads', { orderBys: 'uploadedDate' })
          }
        }
      }
      xmlHttp.open('POST', cloudFunctionImportUrl, true) // true for asynchronous
      xmlHttp.setRequestHeader('Content-Type', 'application/json')
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + idToken)
      console.log('Stringify: ' + JSON.stringify({filename: payload.filename, status: payload.status}))
      xmlHttp.send(JSON.stringify(
        {
          filename: payload.filename,
          status: payload.status
        }
      ))
    }).catch(function (err) {
      context.commit('toggleImportingModal', false)
      context.state.importFailedMessage = err.message
      context.commit('toggleImportingFailedModal', true)
    })
  },
  updateFileStatus (context, payload) {
    let docId = payload.docId
    let status = payload.status
    let docRef = context.rootState.firestoreDB.collection(context.state.uploadedInvoicesCollectionName).doc(docId)
    docRef.update({status: status}).then(function () {
      console.log('Import file updated to ' + status)
    }).catch(function (err) {
      console.error(err)
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/invoiceuploadstoremodule.js